import { domToReact } from 'html-react-parser';

import { parserOptions } from '@commons/components/RichText';
import type { Template } from '@commons/components/RichText/templates';
import Flex from '@commons/containers/Flex';

/**
 * Three columns CKEditor template.
 *
 * @param nodes - An array of DOM nodes to render.
 *
 * @returns A rendered React component.
 */

const ThreeColumnsTemplate: Template = ({ nodes }) => (
  <Flex gap="md" width={12} direction={{ xs: 'column', md: 'row' }}>
    {domToReact(nodes, parserOptions)}
  </Flex>
);

export default ThreeColumnsTemplate;
